import React from 'react';
import { Pagination, Form } from 'react-bootstrap';
import { ITEMS_PER_PAGE_OPTIONS } from '../constants/pagination';

const PaginationComponent = ({
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  onItemsPerPageChange,
  itemName = 'itens'
}) => {
  return (
    <>
      {/* Paginação - Sempre mostrar se houver itens */}
      {totalItems > 0 && totalPages > 1 && (
        <div className="d-flex justify-content-center mt-3">
          <Pagination>
            <Pagination.First 
              onClick={() => onPageChange(1)} 
              disabled={currentPage === 1}
            />
            <Pagination.Prev 
              onClick={() => onPageChange(currentPage - 1)} 
              disabled={currentPage === 1}
            />
            
            {[...Array(totalPages)].map((_, i) => {
              const pageNumber = i + 1;
              
              // Sempre mostrar primeira página
              if (pageNumber === 1) {
                return (
                  <Pagination.Item 
                    key={pageNumber} 
                    active={pageNumber === currentPage}
                    onClick={() => onPageChange(pageNumber)}
                  >
                    {pageNumber}
                  </Pagination.Item>
                );
              }
              
              // Sempre mostrar última página
              if (pageNumber === totalPages && totalPages > 1) {
                return (
                  <Pagination.Item 
                    key={pageNumber} 
                    active={pageNumber === currentPage}
                    onClick={() => onPageChange(pageNumber)}
                  >
                    {pageNumber}
                  </Pagination.Item>
                );
              }
              
              // Mostrar páginas ao redor da atual (exceto primeira e última que já foram tratadas)
              if (pageNumber > 1 && pageNumber < totalPages && 
                  pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1) {
                return (
                  <Pagination.Item 
                    key={pageNumber} 
                    active={pageNumber === currentPage}
                    onClick={() => onPageChange(pageNumber)}
                  >
                    {pageNumber}
                  </Pagination.Item>
                );
              }
              
              // Mostrar reticências se necessário
              if ((pageNumber === 2 && currentPage > 4) ||
                  (pageNumber === totalPages - 1 && currentPage < totalPages - 3)) {
                return <Pagination.Ellipsis key={`ellipsis-${pageNumber}`} />;
              }
              
              return null;
            })}
            
            <Pagination.Next 
              onClick={() => onPageChange(currentPage + 1)} 
              disabled={currentPage === totalPages}
            />
            <Pagination.Last 
              onClick={() => onPageChange(totalPages)} 
              disabled={currentPage === totalPages}
            />
          </Pagination>
        </div>
      )}
      
      {/* Controles de itens por página e contador */}
      {totalItems > 0 && (
        <div className="d-flex justify-content-between align-items-center mt-2">
          <Form.Group className="d-flex align-items-center">
            <Form.Label className="me-2 mb-0">Itens por página:</Form.Label>
            <Form.Select 
              value={itemsPerPage}
              onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
              style={{ width: '80px' }}
            >
              {ITEMS_PER_PAGE_OPTIONS.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </Form.Select>
          </Form.Group>
          
          <div>
            {totalItems > 0 ? (
              `Mostrando ${Math.min((currentPage - 1) * itemsPerPage + 1, totalItems)} a ${Math.min(currentPage * itemsPerPage, totalItems)} de ${totalItems} ${itemName}`
            ) : (
              `Nenhum ${itemName.slice(0, -1)} no período`
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PaginationComponent; 